const saveToLocalStorage = (key: string, payload: Record<string, unknown>) => {
  localStorage.setItem(key, JSON.stringify(payload))
}

export default saveToLocalStorage
